<script lang="ts">
	import { format } from 'svelte-i18n';
	import { ControlsContainer, Text, Toggle } from '@Shelly/shelly-design-system';
	import { createEventDispatcher } from 'svelte';

	export let disabled = false;
	$: isChecked = disabled === false;

	const dispatch = createEventDispatcher();
</script>

<Toggle
	class="d-flex mb-s"
	bind:checked={isChecked}
	size="l"
	on:click={() => {
		disabled = isChecked;
		dispatch('thermostatStateChange', { disabled });
	}}
	id="toggle-21hzz7r"
	>{$format('choose_thermostat_state_enable', {
		default: 'Choose temperature or disable thermostat',
	})}
</Toggle>
